import Breadcrumb from "@/layouts/breadcrumb";

export default new Breadcrumb();
